import axios from "axios";
import moment from "moment/moment";
import { client } from "../Context/orgContext";

export const getBearerToken = () => {
  const token = localStorage.getItem("BearerToken");
  if (!token) {
    return false;
  } else {
    return JSON.parse(token);
  }
};

export const setBearerToken = (token) => {
  localStorage.setItem("BearerToken", JSON.stringify(token));
};

export const authenticateService = async (email, password) => {
  const token = getBearerToken();
  if (
    token &&
    token.jwt &&
    token.token_expiry_time &&
    moment().utc().isBefore(token.token_expiry_time) &&
    moment().utc().diff(token.token_expiry_time, "minutes") < -10
  ) {
    return token;
  } else {
    const encodedData = localStorage.getItem("encodedData");
    if (!encodedData) {
      return false;
    } else {
      return axios
        .post(
          "/api/v1/endUser/login",
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${encodedData}`,
            },
          }
        )
        .then((response) => {
          if (response.data && response.data.jwt) {
            setBearerToken(response.data);
            return response.data;
          } else {
            return false;
          }
        });
    }
  }
};

export const login = async (encodedData) => {
  return axios
    .post(
      `/api/v1/endUser/login?organizationDomainName=${client}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedData}`,
        },
      }
    )
    .then((response) => {
      if (response.data && response.data.jwt) {
        setBearerToken(response.data);
        return response.data;
      } else {
        return false;
      }
    });
};

export const getOrgDetails = async () => {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  const sessionData = sessionStorage.getItem("orgDetails");
  if (sessionData !== null) {
    const clientFavIcon = JSON.parse(sessionData)?.client_favicon_url || null;
    if(clientFavIcon !== null){
      link.href = clientFavIcon;
      document.head.appendChild(link);
    }
    return sessionData;
  } else {
    return axios
      .get(
        `/api/v1/endUser/getOrganisationDetailsByDomainName?domain_name=${client}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        const data = JSON.stringify(response.data.data);
        const clientFavIcon = data.data?.client_favicon_url || null;
        if(clientFavIcon !== null ){
          link.href = clientFavIcon;
          document.head.appendChild(link);
        }
        sessionStorage.setItem("orgDetails", data);
        return data;
      });
  }
};

export const getOrgUserDetails = async () => {
  const token = getBearerToken();
  return axios
    .get(
      `/api/v1/endUser/admin/dashboard/getClinicDetails`,
      {
        headers: {
          Authorization: `Bearer ${token.jwt}`,
        },
      }
    )
    .then((response) => {
      return response.data.data
    });
};

export const getAllClientsData = async () => {
  const token = getBearerToken();
  return axios
    .get(
      `/api/v1/endUser/admin/dashboard/getClinicDetails`,
      {
        headers: {
          Authorization: `Bearer ${token.jwt}`,
        },
      }
    )
    .then((response) => {
      return response.data.data
    });
};

export const deleteClient = async ( clientData ) => {
  const token = getBearerToken();
  return axios
    .delete(
      `/api/v1/endUser/clinic/${clientData.clinic_id}`,
      {
        headers: {
          Authorization: `Bearer ${token.jwt}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return response.data.data
    });
};

export const createClient = async ( clientData ) => {
  const token = getBearerToken();
  const orgDetails  = await getOrgDetails();
  const { organisation_id } = JSON.parse(orgDetails);
  return axios
    .post(
      `/api/v1/endUser/clinic`,
      {
        "clinic_name" : clientData.clientName,
        "organisation" : {
            "organisation_id" : organisation_id
        }
      },
      {
        headers: {
          Authorization: `Bearer ${token.jwt}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return response.data.data
    });
};

export const editClient = async ( updatedData, orignalData ) => {
  const token = getBearerToken();
  const orgDetails  = await getOrgDetails();
  const { organisation_id } = JSON.parse(orgDetails);
  return axios
    .put(
      `/api/v1/endUser/clinic`,
      {
        "id" : orignalData.clinic_id,
        "clinic_name" : updatedData.clientName,
        "clinic_code" : orignalData.clinic_code,
        "clinic_assessment_link" : orignalData.clinic_assessment_link,
        "organisation" : {
            "organisation_id" : organisation_id
        }
      },
      {
        headers: {
          Authorization: `Bearer ${token.jwt}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return response.data.data
    });
};

export const searchClient = async (query) => {
  const token = getBearerToken();
  const orgDetails  = await getOrgDetails();
  const { organisation_id } = JSON.parse(orgDetails);
  return axios
    .get(
      `/api/v1/endUser/clinic/searchByQuery?query=${query}&organisationId=${organisation_id}`,
      {
        headers: {
          Authorization: `Bearer ${token.jwt}`,
        },
      }
    )
    .then((response) => {
      return response.data.data
    });
};